<template>
  <v-row class="reverse-sm" align="center">
    <v-col cols="12" md="6">
      <div class="hero-text">
        <!-- Badge de categoria -->
        <div class="hero-badge">
          <v-icon small class="mr-1" color="error">mdi-glass-cocktail</v-icon>
          Cardápio Digital no Tablet
        </div>

        <h1 class="headline-text mt-3">
          Seu Cliente Pede Sozinho, Você Vende Mais
        </h1>

        <p class="subheadline-text mt-4">
          Com o cardápio digital no tablet, você aumenta o ticket médio, reduz a mão de obra e agiliza o atendimento.
        </p>

        <ul class="hero-bullets mt-5">
          <li v-for="(b, i) in bullets" :key="i">
            <v-icon small color="success" class="mr-2">mdi-check-circle</v-icon>{{ b }}
          </li>
        </ul>

        <div class="mt-6">
          <CtaButton>Quero no meu restaurante</CtaButton>
        </div>
      </div>
    </v-col>

    <v-col cols="12" md="6" class="d-flex justify-center">
      <div class="video-shell">
        <iframe
          src="https://www.youtube-nocookie.com/embed/xFcf-gerWpk"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="Cardápio digital no tablet de mesa"
          class="video-frame"
        />
      </div>

      <!-- <img
        :src="require('@/assets/images/tablet-hero.webp')"
        class="hero-img"
        alt="Tablet de autoatendimento em suporte de mesa exibindo o cardápio de pizzas do ZaperMenu"
        width="1200"
        height="810"
        decoding="async"
        loading="eager"
        fetchpriority="high"
      /> -->
    </v-col>
  </v-row>
</template>

<script>
  import CtaButton from '@/components/CtaButton.vue';

  export default {
    name: 'TabletHero',

    components: {
      CtaButton,
    },

    data: () => ({
      bullets: [
        'Aumento de até 60% do ticket médio',
        'Acaba com os erros de anotação',
        'Redução de até 50% da mão de obra',
      ],
    }),
  };
</script>

<style lang="scss" scoped>
  .hero-text {
    width: 92%;
    margin: 0 auto;

    @media (max-width: 780px) {
      width: 100%;
    }
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 999px;
    border: 1px solid rgba(244, 6, 18, 0.35);
    background: rgba(244, 6, 18, 0.08);
    font-size: 13px;
    font-weight: 600;
    color: #f40612;
    letter-spacing: 0.02em;
  }

  .headline-text {
    font-size: 50px;
    font-weight: 700;
    line-height: 1.1;

    background: linear-gradient(90deg, #f40612 0%, #ff4d1a 25%, #ffb347 50%, #ff4d1a 75%, #f40612 100%);
    background-size: 250% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: headline-shimmer 4s linear infinite;

    @media (max-width: 780px) {
      font-size: 36px;
    }
  }

  @keyframes headline-shimmer {
    0%   { background-position: 0% center; }
    100% { background-position: 250% center; }
  }

  .subheadline-text {
    font-size: 17px;
    font-weight: 400;
    line-height: 1.75;
    color: var(--text-secondary);
    border-left: 3px solid rgba(244, 6, 18, 0.4);
    padding-left: 14px;
    margin: 0;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .hero-bullets {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: var(--text-secondary);
      margin-bottom: 8px;
    }
  }

  .video-shell {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
    width: 100%;
    max-width: 300px;

    @media (max-width: 600px) {
      max-width: 240px;
    }
  }

  .video-frame {
    display: block;
    width: 100%;
    aspect-ratio: 9 / 16;
    border: none;
  }

  .hero-img {
    display: block;
    width: 100%;
    max-width: 540px;
    height: auto;
    animation: hero-float 6s ease-in-out infinite;
  }

  @keyframes hero-float {
    0%,100% { transform: translateY(0); }
    50%     { transform: translateY(-7px); }
  }

  .reverse-sm {
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }
</style>
